import { render, staticRenderFns } from "./customerOrderAssessmentRead.vue?vue&type=template&id=35454b8a&scoped=true&"
import script from "./customerOrderAssessmentRead.vue?vue&type=script&lang=js&"
export * from "./customerOrderAssessmentRead.vue?vue&type=script&lang=js&"
import style0 from "./customerOrderAssessmentRead.vue?vue&type=style&index=0&id=35454b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35454b8a",
  null
  
)

export default component.exports